export const REACT_DASHBOARD = "/dashboard";
export const REACT_LANDING = "/landing";
export const REACT_HQ_DASHBOARD = "/RetailManagment";
export const REACT_RETAIL_CLIENT_LIST = "/retail-client";
export const REACT_RETAIL_CLIENT_ADD = "/retail-client/add";
export const REACT_RETAIL_CLIENT_UPDATE = "/retail-client/update";
export const REACT_RETAIL_CLIENT_VIEW = "/retail-client-details";
export const REACT_OUTLET_LIST = "/outlet";
export const REACT_OUTLET_ADD = "/outlet/add";
export const REACT_OUTLET_EDIT = "/outlet/update";
export const REACT_OUTLET_VIEW = "/outlet/view";

export const REACT_DEVICE_LIST = "/device";
export const REACT_DEVICE_ADD_INSTRUCTIONS = "/gateway/add/instructions";
export const REACT_DEVICE_ADD = "/gateway/add";
export const REACT_DEVICE_DETAILS = "/device/view";
export const REACT_DEVICE_GATEWAY = "/gateway";
export const REACT_DEVICE_SCREENS = "/screens";
export const REACT_DEVICE_EDIT_SCREENS = "/editScreens/";
export const REACT_DEVICE_VIEW = "/deviceView";

export const REACT_LOCATION_LIST = "/location";
export const REACT_CITYZONE_LIST = "/location/city-zone";
export const REACT_CITYZONE_ADD = "/location/city-zone/add";
export const REACT_CITYZONE_VIEW = "/location/city-zone/view/";
export const REACT_CITYZONE_EDIT = "/location/city-zone/edit/";

//Country
export const REACT_COUNTRY_LIST = "/location/country";
export const REACT_COUNTRY_ADD = "/location/country/add";
export const REACT_COUNTRY_EDIT = "/location/country/edit/";
export const REACT_COUNTRY_VIEW = "/location/country/view/";

// State
export const REACT_STATE_LIST = "/location/state";
export const REACT_STATE_ADD = "/location/state/add";
export const REACT_STATE_EDIT = "/location/state/edit/";
export const REACT_STATE_VIEW = "/location/state/view/";

//City
export const REACT_CITY_LIST = "/location/city";
export const REACT_CITY_VIEW = "/location/city/view/";
export const REACT_CITY_ADD = "/location/city/add";
export const REACT_CITY_EDIT = "/location/city/edit/";

export const REACT_OUTLET_TYPE_LIST = "/location/outlet_type";
export const REACT_OUTLET_TYPE_ADD = "/location/outlet_type/add";
export const REACT_OUTLET_TYPE_EDIT = "/location/outlet_type/update/";
export const REACT_OUTLET_TYPE_VIEW = "/location/outlet_type/";

export const REACT_WORKSHOP = "/workshop";

export const REACT_FORGOT_PASSWORD = "/forgot-password";
export const REACT_RESET_COMPANY_PASSWORD = "/company/activate-account";

export const REACT_DATA_ACCESS_CONTROL = "/data-access-control/";
export const REACT_DATA_ACCESS_CONTROL_DEVICE =
  "/data-access-control/access-device/";
export const REACT_DATA_ACCESS_CONTROL_CLIENT =
  "/data-access-control/access-client/";
export const REACT_DATA_ACCESS_CONTROL_PRINCIPALS =
  "/data-access-control/access-principals/";

export const REACT_PRINCIPAL_MANAGEMENT = "/principal";
export const REACT_PRINCIPAL_ADD = "/principal/add";
export const REACT_PRINCIPAL_EDIT = "/principal/edit/";

export const REACT_VIEW_USER_PROFILE = "/view-user-profile";
export const REACT_UPDATE_USER_PROFILE = "/update-user-profile";

export const RETAIL_CLIENT = "/retail-client/";
export const REACT_PERSON_LIST = "/person/list";
export const REACT_PERSON_ADD = "/person/add";
export const REACT_PERSON_VIEW = "/person/view/";
export const REACT_PERSON_EDIT = "/person/edit/";

export const REACT_VIEW_COMPANY_PROFILE = "/view-company-profile";

export const REACT_TEMPLATE = "/template";
export const REACT_PICTURE_LIBRARY = "/picture-library";
export const REACT_PICTURE_LIBRARY_ADD = "/picture-library/add";
export const REACT_PICTURE_LIBRARY_EDIT = "/picture-library/edit/";
export const REACT_TEMPLATE_LIST = "/template";
export const REACT_TEMPLATE_VIEW = "/template/view/";
export const REACT_TEMPLATE_EDIT = "/template/edit/";
export const REACT_TEMPLATE_ADD = "/template/add";
export const REACT_UPDATE_TEMPLATE = "/template/updateTemplate";

export const REACT_PRODUCT = "/product";
export const REACT_PRODUCT_ADD = "/product/add";
export const REACT_PRODUCT_VIEW = "/product/view";
export const REACT_PRODUCT_EDIT = "/product/edit";
export const REACT_PRODUCT_LABEL = "/label-product";
export const REACT_PRODUCT_BIND_TO_SCREEN = "/screens/bind";

export const REACT_PRICE_CHANGE_RULES = "/price-change-rules";
export const REACT_PRICE_CHANGE_RULES_VIEW = "/price-change-rules/view/";
export const REACT_PRICE_CHANGE_RULES_EDIT = "/price-change-rules/edit/";
export const REACT_ADD_PRICE_CHANGE_RULES = "/price-change-rules/add";
export const REACT_PRICE_CHANGE_EVENT = "/price-change-event";
export const REACT_PRICE_CHANGE_EVENT_ADD = "/price-change-event/add";
export const REACT_PRICE_CHANGE_EVENT_VIEW = "/price-change-event/view/";
export const REACT_PRICE_CHANGE_EVENT_UPDATE = "/price-change-event/update";
export const REACT_SCEEN_LOGS = "/system-logs/";

export const REACT_APPROVAL_FLOW_CHART_LIST = "/approval-flowchart";
export const REACT_APPROVAL_FLOW_CHART_ADD = "/approval-flowchart/add";
export const REACT_APPROVAL_FLOW_CHART_EDIT = "/approval-flowchart/edit/";
export const REACT_APPROVAL_LIST = "/approval/list";
export const REACT_APPROVAL_LIST_VIEW = "/approval/list/view";
export const REACT_APPROVAL_LOG = "/approval/log";
export const REACT_CREATE_TEMPLATE = "/template/createTemplate";
//User managemnet
export const REACT_USER = "/user";
export const REACT_USER_ADD = "/user/add";
export const REACT_USER_EDIT = "/user/edit";
export const REACT_USER_VIEW = "/user/view";
export const REACT_AUTHORIZATION_LEVEL = "/authorization-level";
export const REACT_AUTHORIZATION_LEVEL_ADD = "/authorization-level/add";
export const REACT_AUTHORIZATION_LEVEL_EDIT = "/authorization-level/edit";
export const REACT_AUTHORIZATION_LEVEL_VIEW = "/authorization-level/view";

export const REACT_THIRD_PARTY_LIST = "/third-party";
export const REACT_THIRD_PARTY_ADD = "/third-party/add";

//User managemnet
export const REACT_TEMPLATE_EDITOR = "/editor";

//Subscription

export const REACT_SUBSCRIPTION = "/subscription";
export const REACT_SUBSCRIPTION_CREATE = "/subscription/create";
export const REACT_CREATE_SUBSCRIPTION_RECORD = "/subscription_records";

//MobileApiManagement
export const REACT_MOBILE_API_MANGEMENT = "/mobile_api_management_records";
export const REACT_CREATE_MOBILE_API_MANGEMENT =
  "/create_mobile_api_management_records";
export const REACT_EDIT_MOBILE_API_MANGEMENT = "/edit_mobile_api_management/";

export const REACT_LOGIN_LOG = "/login_log";
export const REACT_OPERATION_LOG = "/oper_log";
export const REACT_OPERATION_LOG_DETAIL = "/operation/log/detail";

export const REACT_PAGE_DACCUEIL = "/localiser/page/daccueil";
export const REACT_PRODUCT_INFORMATIONS = "/localiser/produit/infomations";
export const REACT_CLIENT_APERCUS = "/localiser/client/apercus";
